
/**
 * Module dependencies.
 */

import { color, units } from 'src/styles/utils';
import { ifProp } from 'styled-tools';
import IconButton from 'src/components/core/buttons/icon-button';
import React, { ReactElement } from 'react';
import arrowLeftIcon from 'src/assets/svg/arrow-left.svg';
import arrowRightIcon from 'src/assets/svg/arrow-right.svg';
import styled, { css } from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  className?: string,
  disabled?: boolean,
  onClick: () => void,
  type: 'next' | 'previous'
};

/**
 * `StyledIconButton` styled component.
 */

const StyledIconButton = styled(IconButton)<{ disabled: string }>`
  ${ifProp('disabled', css`
    color: ${color('grey600')};
    cursor: default;
    pointer-events: none;
  `)}

  &.disabled {
    color: ${color('grey600')};
    cursor: default;
    pointer-events: none;
  }
`;

/**
 * `SliderNavigation` component.
 */

const SliderNavigation = (props: Props): ReactElement => {
  const { type, ...rest } = props;

  return (
    <StyledIconButton
      {...rest}
      aria-label={type === 'next' ? 'Next' : 'Previous'}
      icon={type === 'next' ? arrowRightIcon : arrowLeftIcon}
      iconSize={units(5)}
    />
  );
};

/**
 * Export `SliderNavigation` component.
 */

export default SliderNavigation;
